export default {
  form: {
    header: "Dane modułu",
    title: "Opcjonalny tytuł",
    module: "Moduł",
    submodule: "Powiązany",
    device: "Web/Mobile",
    is_active: "Pokazuj na wall",
    selectmodule: "Wybierz moduł",
    selectsubmodule: "Wybierz powiązany",
    material: "Materiał",
    materials: "Materiały",
    selectmaterial: "Wybierz materiał",
    use_workbook_cover: "Użyj okladki workbook",
    tag: "Tag",
    for_ceo: "Dla CEO",
    bg_border: "Granica tła",
    headers: {
      info: "Ułóż kolejność sekcji na wall",
    },
    tabs: {
      web: "Web",
      mobile: "Mobile",
      normal: "Zwykły",
      ceo: "CEO",
    },
    buttons: {
      saveData: "Zapisz zmiany",
      addData: "Dodaj pozycję",
      cancel: "Anuluj",
    },
  },
  duplicator: {
    title: "Duplikator modułów",
    description: "Kopiuj moduły między różnymi trybami i urządzeniami",
    sections: {
      normalToCeo: "Zwykły → CEO",
      ceoToNormal: "CEO → Zwykły",
      withinMode: "W ramach trybu",
    },
    buttons: {
      normalWebToCeoWeb: "Zwykły Web → CEO Web",
      normalWebToCeoMobile: "Zwykły Web → CEO Mobile",
      normalMobileToCeoWeb: "Zwykły Mobile → CEO Web",
      normalMobileToCeoMobile: "Zwykły Mobile → CEO Mobile",
      ceoWebToNormalWeb: "CEO Web → Zwykły Web",
      ceoWebToNormalMobile: "CEO Web → Zwykły Mobile",
      ceoMobileToNormalWeb: "CEO Mobile → Zwykły Web",
      ceoMobileToNormalMobile: "CEO Mobile → Zwykły Mobile",
      normalWebToNormalMobile: "Zwykły Web → Zwykły Mobile",
      normalMobileToNormalWeb: "Zwykły Mobile → Zwykły Web",
      ceoWebToCeoMobile: "CEO Web → CEO Mobile",
      ceoMobileToCeoWeb: "CEO Mobile → CEO Web",
    },
  },
};
